import React from 'react'
import {
  CheckboxLabel,
  FlexContainer,
  MathFormulaDisplay,
  Paper,
  CustomModalStyled,
  RadioBtn,
} from '@edulastic/common'
import { Col, Row, Spin } from 'antd'
import { sanitizeHtml } from '@edulastic/common/src/utils/html'
import { Container } from './styled/Container'
import { ELOList } from './styled/ELOList'
import { TLOList, TLOListItem } from './styled/TLOList'

const PAStandardsModal = ({
  visible,
  isRubricFlow,
  onCancel,
  footer,
  state,
  curriculumStandardsLoading,
  curriculumStandardsTLO,
  selectedTLO,
  handleTloClick,
  enableSelectAll,
  indeterminate,
  handleCheckAll,
  allChecked,
  filteredELO,
  singleSelect,
  handleCheckELO,
}) => {
  return (
    <CustomModalStyled
      title={`Select Standards for This ${
        isRubricFlow ? 'Criteria' : 'Question'
      }`}
      visible={visible}
      onCancel={onCancel}
      footer={footer}
      modalWidth="800px"
      top="50px"
      zIndex={1006}
    >
      <Paper data-cy={`standard-PopUp-${visible}`}>
        <br />
        <Spin spinning={curriculumStandardsLoading} size="large">
          <Row type="flex" gutter={24}>
            <Col md={8} style={{ overflow: 'hidden' }}>
              <TLOList>
                {curriculumStandardsTLO.map((tlo) => (
                  <TLOListItem
                    title={tlo.identifier}
                    description={tlo.description}
                    active={tlo._id === selectedTLO?._id}
                    key={tlo._id}
                    onClick={() => handleTloClick(tlo)}
                  />
                ))}
              </TLOList>
            </Col>
            <Col md={16} style={{ overflow: 'hidden' }}>
              {enableSelectAll && selectedTLO && !curriculumStandardsLoading && (
                <>
                  <Row type="flex">
                    <CheckboxLabel
                      indeterminate={indeterminate}
                      onChange={handleCheckAll}
                      checked={allChecked}
                      textTransform="none"
                      data-cy="allStandards"
                    >
                      All {selectedTLO.identifier} Standards
                    </CheckboxLabel>
                  </Row>
                  <br />
                </>
              )}
              <ELOList padding="0">
                <Container padding="15px" borderRadius="0px">
                  {filteredELO.map((c) => (
                    <FlexContainer
                      key={c._id}
                      alignItems="flex-start"
                      justifyContent="flex-start"
                      style={{ marginBottom: 15 }}
                    >
                      {singleSelect ? (
                        <RadioBtn
                          data-cy={c.identifier}
                          onChange={() => handleCheckELO(c)}
                          checked={state.eloStandards.some(
                            (item) => item._id === c._id
                          )}
                          style={{ marginRight: '10px' }}
                        />
                      ) : (
                        <CheckboxLabel
                          singleSelect={singleSelect}
                          data-cy={c.identifier}
                          onChange={() => handleCheckELO(c)}
                          checked={state.eloStandards.some(
                            (item) => item._id === c._id
                          )}
                          style={{ marginRight: '10px' }}
                        />
                      )}
                      <div>
                        <b>{c.identifier}</b>
                        <MathFormulaDisplay
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(c.description),
                          }}
                        />
                      </div>
                    </FlexContainer>
                  ))}
                </Container>
              </ELOList>
            </Col>
          </Row>
        </Spin>
      </Paper>
    </CustomModalStyled>
  )
}

export default PAStandardsModal
